import { SURFACES } from '../../config/productSurfaces';

/**
 * Map RSVP mutation results to navigation / modal / toast side effects.
 */
export function handleRsvpWriteResult(
  result,
  { showToast, navigate, setRejoinModal, getRsvpToastMessage },
) {
  if (!result) return null;

  if (result.action === 'going_queue') {
    const classified = result.classified;
    if (!classified) return getRsvpToastMessage?.();

    switch (classified.kind) {
      case 'matched':
        showToast?.("You're matched into a group.");
        navigate?.(`/groups/${classified.groupId}`);
        return null;
      case 'rejoin_available':
        if (classified.candidates?.length > 0) {
          setRejoinModal?.({
            show: true,
            group: classified.candidates[0],
            eventId: result.eventId,
            skippedGroupIds: [],
            remainingCandidates: classified.candidates.slice(1),
          });
          return null;
        }
        return getRsvpToastMessage?.();
      case 'closed':
        showToast?.('Matching is closed for this event.');
        return null;
      case 'queued':
        return getRsvpToastMessage?.();
      case 'rpc_error':
        throw new Error(classified.message || 'Matching failed');
      default:
        return getRsvpToastMessage?.();
    }
  }

  if (result.action === 'going_create') {
    const data = result.outcome;
    if (data?.outcome === 'created') {
      // No toast: the group page opens on an invite card (justCreated) that says it better and holds the button.
      navigate?.(`/groups/${data.group_id}`, { state: { justCreated: true } });
      return null;
    }
    if (data?.outcome === 'closed') {
      showToast?.('Group creation is closed for this event.');
      return null;
    }
    throw new Error(data?.message || 'Failed to create group.');
  }

  return null;
}

export function rsvpActionFromChoice(status, goingChoice) {
  if (status === 'going' && goingChoice === 'skip') return 'going_skip';
  // 'queue' is the DEFAULT goingChoice in four callers (useRsvpWrite, EventDetail,
  // EventsList, useEventRsvpParity), so hiding the Match me button is not enough on
  // its own - an RSVP that named no choice would still join the match queue. With
  // the queue hidden, going with no choice means going, nothing more.
  if (status === 'going' && goingChoice === 'queue')
    return SURFACES.matchMe ? 'going_queue' : 'going_skip';
  if (status === 'going' && goingChoice === 'create') return 'going_create';
  if (status) return 'upsert';
  return 'delete';
}
